<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "advertismentIndex",
  data() {
    return {
      searchTxt: "",
    };
  },
};
</script>
<style lang="less" scoped>

</style>